import React from 'react';
import { type IDataAttributeMap, LargeAutoComplete } from '@secretescapes/falcon';
import { Container } from './PanelInput.styles';

interface Props {
  label: string;
  value: string;
  onClick: () => void;
  dataAttributes?: IDataAttributeMap;
  isDisabled?: boolean;
}

export const PanelInput = ({ label, value, onClick, dataAttributes, isDisabled }: Props) => {
  return (
    <Container>
      <LargeAutoComplete
        dataSource={[]}
        id={label}
        label={label}
        name={label}
        open={false}
        value={value}
        isAutoCompleteEnabled={true}
        isReadOnly={true}
        filterOption={false}
        highlightExactMatchOnly={true}
        onClick={onClick}
        dataAttributes={dataAttributes}
        isDisabled={isDisabled}
      />
    </Container>
  );
};
